var _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowSLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M74.315 29.595L78.5575 33.8375L56.6375 55.7575C55.505 56.89 54.88 58.3975 54.88 60C54.88 61.6025 55.505 63.11 56.6375 64.2425L78.5575 86.1625L74.315 90.405L52.395 68.485C50.1275 66.2175 48.88 63.205 48.88 60C48.88 56.795 50.1275 53.78 52.395 51.515L74.315 29.595Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowSLeft);
export default __webpack_public_path__ + "static/media/Arrow_S_left.bb40dc69.svg";
export { ForwardRef as ReactComponent };